/**
 * 平台名去掉「(联网)/(联网)」后缀(页面另用 ★ 标联网实测)。
 * ★1006:原写法 `.replace(/(联网)/, "")` 里括号是正则捕获组,只删了「联网」二字,留下「智谱GLM()」。
 */
export function platformLabel(label: string): string {
  return label.replace(/[（(]\s*联网\s*[）)]/, "").trim();
}
